var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pldc_section mt-1 pa-2 rounded-lg"},[(_vm.$slots.header)?_c('div',{staticClass:"d-flex pl-1 black--text"},[_vm._t("header")],2):_vm._e(),_c('div',{staticClass:"d-flex flex-column px-1 py-1"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }